import {
  UPDATE_START,
  UPDATE_SUCCESS,
  UPDATE_FAILURE,
  DELETE_SUCCESS,
  DELETE_FAILURE
} from './actions';
import { DELETE_START } from '../users/actions';

const initialState = {
  updating: false,
  updateErrors: null,
  deleting: false
};

export default (state = {}, action) => {
  const newState = Object.assign({}, initialState, state);

  switch (action.type) {
    case UPDATE_START:
      newState.updating = true;
      newState.updateErrors = null;
      break;
    case UPDATE_SUCCESS:
      newState.updating = false;
      break;
    case UPDATE_FAILURE:
      newState.updating = false;
      newState.updateErrors = action.payload;
      break;
    case DELETE_START:
      newState.deleting = true;
      break;
    case DELETE_SUCCESS:
    case DELETE_FAILURE:
      newState.deleting = false;
      break;
    default:
      // oh well!
      break;
  }
  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/user-account/reducer.js